//!!!!! TODO: Do not mutate state directly fix it asap!!!!!!
import React from 'react'
import i18 from '../../../../i18'

class RowUnprocessed extends React.Component {
    constructor(props) {
        super(props);
        this._notificationSystem = null;
        this.state = {
            showTable: true,
            invoice: {},
            bank: {},
            type: '',
            index: 0,
            typeOfTraffic: '',
            typeOfItem: '',
            typeofVSZ: '',
            match_percentage: 0,
            company_name_offered: '',
            typeOfItemFlag: false,
            invoiceNumber: '',
            companyName: '',
            announcement: '',
            main_bookkeeping_number: '',
            legal_title: ''
        }
    }

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use new lifecycle static getDerivedStateFromProps instead.
     */
    componentWillReceiveProps = (nextProps) => {
        this.setState({
            invoice: nextProps.invoice,
            typeOfTraffic: nextProps.invoice.typeOfTraffic,
            typeOfItemFlag: ['v', 'sz', 'PARTNER_VSZ'].includes(nextProps.invoice.typeOfItem),
            typeOfItem: nextProps.invoice.typeOfItem,
            typeOfVSZ: nextProps.invoice.typeOfVSZ,
            invoiceNumber: nextProps.invoice.invoiceNumber,
            companyName: nextProps.invoice.companyName,
            match_percentage: nextProps.invoice.match_percentage,
            company_name_offered: nextProps.invoice.company_name_offered,
            type: nextProps.type,
            announcement: nextProps.invoice.announcement ? nextProps.invoice.announcement : '-',
            main_bookkeeping_number: nextProps.invoice.main_bookkeeping_number,
            legal_title: nextProps.invoice.typeOfVSZ === 'v' ? 'V01' : (nextProps.invoice.typeOfVSZ === 'sz' ? 'K01' : ''),
            index: nextProps.keyIndex,
            bank: nextProps.bank,
        })
    }


    onElementChange = (event) => {
        event.preventDefault()
        let elementName = event.target.attributes.name.nodeValue;
        let invoice = this.state.invoice;
        invoice[elementName] = event.target.value;
        this.setState({
            [elementName]: event.target.value,
            invoice: invoice
        });
    }

    onElementBlur = (event) => {

        event.preventDefault();
        let elementName = event.target.attributes.name.nodeValue;
        let invoice = this.state.invoice;

        // if (elementName === 'main_bookkeeping_number') {
        //     if (this.props.bank.upload.company.accountant_program_id === 2 && (event.target.value < 100000000 || event.target.value > 999999999)) {
        //         alert('A főkönyvi számnak 9 karakteresnek kell lennie. A beállítás nem lett elmentve.');
        //
        //         invoice[elementName] = '';
        //         this.setState({
        //             [elementName]: '',
        //             invoice: invoice
        //         });
        //         return false;
        //     }
        // }


        invoice[elementName] = event.target.value;
        this.setState({
            [elementName]: event.target.value,
            invoice: invoice
        });
    }


    confirmAutoMatching = () => {
        if (this.state.type === 'unprocessed') {
            let invoice = this.state.invoice;

            document.body.classList.toggle('loading-body', true);
            this.props.onConfirmAutoMatching(this.state.invoice);
            setTimeout(() => {
                this.props.onSetProcessedItemsFlag();
                document.body.classList.remove('loading-body');
                invoice.main_bookkeeping_number = '';
                invoice.legal_title = '';

                this.setState({
                    invoice: invoice
                })
            }, 300)
        }
    }

    onSetItemType = () => {
        if (this.state.type === 'unprocessed') {
            let invoice = this.state.invoice;
            this.props.onShowModal(this.state.invoice);
            document.body.classList.toggle('loading-body', true);
            setTimeout(() => {
                this.props.onSetProcessedItemsFlag();
                document.body.classList.remove('loading-body');
                invoice.main_bookkeeping_number = '';
                invoice.legal_title = '';
                this.setState({
                    invoice: invoice
                })
            }, 300)
        }
    }


    onCreateRule = (event) => {
        if (!this.state.main_bookkeeping_number) {
            this.props._addNotification('Kérünk ellenőrizze a Fők. szám mezőt.', 'error');
            return
        }
        if (this.props.bank.upload.company.accountant_program_id === 2) {
            if (!this.state.legal_title) {
                this.props._addNotification('Kérünk ellenőrizze a Jogcímkód mezőt.', 'error');
                return
            }
        }

        // if (!this.leastOneCheckBoxSelected()) {
        //     this.state.invoice.announcementCbox = true;
        //     this.state.invoice.companyChkBox = true;
        //     this.state.invoice.invoiceChkBox = true;
        //     this.state.invoice.typeOfTrafficChkBox = true;
        // }

        let data = this.buildInvoiceObj();
        this.props.onCreateRule(event, data, this.state.type)
    };

    buildInvoiceObj = () => {
        let data = {};

        if (this.state.invoice.announcementCbox) {
            data.announcement = this.state.invoice.announcement
        }

        if (this.state.invoice.companyChkBox) {
            data.companyName = this.state.invoice.companyName
        }

        if (this.state.invoice.invoiceChkBox) {
            data.invoiceNumber = this.state.invoice.invoiceNumber
        }

        if (this.state.invoice.typeOfTrafficChkBox) {
            data.typeOfTraffic = this.state.typeOfTraffic
        }

        data.main_bookkeeping_number = this.state.main_bookkeeping_number;
        data.legal_title = this.state.legal_title;
        data.sum_type = (this.state.invoice.sum > 0 ? '+' : '-');

        return data
    };

    leastOneCheckBoxSelected = () => {
        return this.state.invoice.typeOfTrafficChkBox
            || this.state.invoice.invoiceChkBox
            || this.state.invoice.companyChkBox
            || this.state.invoice.announcementCbox;
    };

    changeTypeOfItem = (event) => {
        let elementName = event.target.attributes.name.nodeValue;
        let invoice = this.state.invoice;
        invoice[elementName] = event.target.value;
        this.setState({
            [elementName]: event.target.value,
            invoice: invoice
        });
    };

    handleChangeChk = event => {
        let invoice = this.state.invoice;
        invoice[event.target.attributes.name.nodeValue] = event.target.value === 'on';
        this.setState({
            invoice: invoice
        });
    };

    render() {
        let typeOfTrafficChkBoxId = Math.random(9999, 99999);
        let invoiceChkBoxId = Math.random(9999, 99999);
        let companyChkBoxId = Math.random(9999, 99999);
        let announcementChkBoxId = Math.random(9999, 99999);
        return (
            <tr index={this.state.index}>
                <td>
                    <input name='typeOfTrafficChkBox' data-index={this.state.index.toString()} id={typeOfTrafficChkBoxId} type="checkbox" defaultChecked={this.state.invoice.typeOfTrafficChkBoxId} onChange={(event) => this.handleChangeChk(event)}/>
                    <label htmlFor={typeOfTrafficChkBoxId}></label>
                    <input name='typeOfTraffic' onChange={(event) => this.onElementChange(event)} value={this.state.typeOfTraffic} className='typeOfTraffic no-border-underline-text-input' type='text'/>
                </td>
                <td>{this.state.invoice.day}</td>
                <td>{new Intl.NumberFormat('hu-HU', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(this.state.invoice.sum)} {this.state.invoice.currency}</td>
                <td className='invoice-number-td'>
                    <input name='invoiceChkBox' data-index={this.state.index.toString()} id={invoiceChkBoxId} type="checkbox" defaultChecked={this.state.invoice.invoiceNumberCbox} onChange={(event) => this.handleChangeChk(event)}/>
                    <label htmlFor={invoiceChkBoxId}>{this.state.invoiceNumber ? this.state.invoiceNumber : '-'}</label>
                </td>
                <td>
                    <input name='companyChkBox' data-index={this.state.index.toString()} id={companyChkBoxId} type="checkbox" defaultChecked={this.state.invoice.companyNameCbox} onChange={(event) => this.handleChangeChk(event)}/>
                    <label htmlFor={companyChkBoxId}></label>
                    <input name='companyName' onChange={(event) => this.onElementChange(event)} value={this.state.companyName} className='companyName no-border-underline-text-input' type='text'/>
                </td>
                <td>
                    <table>
                        <tbody>
                        <tr className='no-border transparent-bg'>
                            <td>
                                <input name='announcementCbox' data-index={this.state.index.toString()}
                                       id={announcementChkBoxId}
                                       type="checkbox"
                                       defaultChecked={this.state.invoice.announcementCbox} onChange={(event) => this.handleChangeChk(event)}/>
                                <label htmlFor={announcementChkBoxId}></label>
                            </td>
                            <td>
                                <input name='announcement'
                                       onChange={(event) => this.onElementChange(event)}
                                       value={this.state.announcement}
                                       className='no-border-underline-text-input announcement' type='text'/>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </td>
                <td>
                    {
                        this.state.company_name_offered ?
                            <label htmlFor={companyChkBoxId}>
                                V/SZ cég: <b>{this.state.company_name_offered ? this.state.company_name_offered : '-'}</b>
                            </label>
                            : <label>Típus:&nbsp;<b>ISMERETLEN TÉTEL</b></label>
                    }
                    <br/>
                    <a className='next-step-small next-step' onClick={() => this.onSetItemType()}>
                        <i className="fa small-fa-icon fa-hand-pointer-o" aria-hidden="true"></i>&nbsp;
                        {this.state.company_name_offered ? 'Cég csere' : 'V/SZ beállítása'}
                    </a>&nbsp;&nbsp;
                    {
                        this.state.company_name_offered ? <a className='next-step-small next-step' onClick={() => this.confirmAutoMatching()}>
                            <i className="fa small-fa-icon fa-floppy-o" aria-hidden="true"></i>&nbsp;Mentés
                        </a> : null
                    }
                </td>
                <td>
                    <input onChange={(event) => this.onElementChange(event)}
                           onBlur={(event) => this.onElementBlur(event)}
                           value={this.state.main_bookkeeping_number}
                           name='main_bookkeeping_number'
                           className={this.state.typeOfItemFlag ? 'd-none' : 'bordered-input mainBookKeepingNumber-input'}
                           type='text' maxLength="9"/>
                </td>
                {this.props.bank.upload.company.accountant_program_id === 2
                    ? <td>
                        <select value={this.state.typeOfVSZ == 'v' ? 'V01' : (this.state.typeOfVSZ == 'sz' ? 'K01' : this.state.legal_title)}
                                name='legal_title'
                                onChange={(event) => this.onElementChange(event)}
                                className={this.state.typeOfItemFlag ? 'd-none' : 'bordered-input legalTitle-input'}>
                            <option value=""></option>
                            <option value="B03">B03 - Kölcsönfelvétel</option>
                            <option value="B04">B04 - Tagi kölcsön felvétele</option>
                            <option value="B05">B05 - Tartós alapítói vagyon rendelkezésre bocsátása</option>
                            <option value="B06">B06 - Folyósított kölcsön és kamata</option>
                            <option value="B13">B13 - Kapott osztalék</option>
                            <option value="B99">B99 - Pénzbevétel egyéb forrásból</option>
                            <option value="K03">K03 - Kölcsön visszafizetése</option>
                            <option value="K04">K04 - Tagi kölcsön visszafizetése</option>
                            <option value="K05">K05 - Tartós alapítói vagyon visszafizetése</option>
                            <option value="K06">K06 - Kölcsön folyósítása</option>
                            <option value="K07">K07 - Munkabér</option>
                            <option value="K08">K08 - Foglalkoztatás terhei</option>
                            <option value="K09">K09 - ÁFA</option>
                            <option value="K10">K10 - Nyereséget terhelő adók</option>
                            <option value="K11">K11 - Helyi adók</option>
                            <option value="K12">K12 - Egyéb adók</option>
                            <option value="K13">K13 - Fizetett osztalék</option>
                            <option value="K99">K99 - Egyéb pénzkiadás</option>
                            <option value="T01">T01 - Technikai</option>
                        </select>
                    </td>
                    : null
                }
                <td>
                    <div className={this.state.typeOfItemFlag ? 'd-none' : 'min-width-50'}>
                        <i onClick={(event) => this.onCreateRule(event)} name='final' title={i18.CUSTOMER._createRulesAndProcess} className='fa fa-dot-circle-o' aria-hidden='true'></i> &nbsp;&nbsp;
                        <i onClick={(event) => this.onCreateRule(event)} name='temporarily' title={i18.CUSTOMER._oneTimeProcessing} className='fa fa-check-circle' aria-hidden='true'></i>
                    </div>
                </td>
            </tr>
        )
    }
}

export default RowUnprocessed


// WEBPACK FOOTER //
// ./src/components/bank/steps/assignment/rowunprocessed.js